<template>
<div>
  <div :class="$style['desc']">
    <span>기존 대시보드를 활용하여 신규 대시보드를 간편하게 추가할 수 있습니다.</span><br/>
    <span>다운로드 받은 대시보드 템플릿 파일을 업로드하여 어디서나 쉽게 대시보드를 만들 수 있습니다.</span>
  </div>
  <div>
    <h4 class="title-bar">대시보드 템플릿 파일 업로드</h4>
    <div>
      <el-input style="width: calc(100% - 195px);" v-model="uploadData.name" readonly></el-input>
      <el-upload
        style="display: inline-block;"
        :auto-upload="false"
        :on-change="onChange"
        action=""
        :show-file-list="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
        <el-button type="primary" class="mr-l4">파일업로드</el-button>
      </el-upload>
      <el-button class="mr-l4" @click="onTemplateDownloadClick">템플릿 다운로드</el-button>
    </div>
  </div>
</div>
</template>

<script>
import DashboardAPI from '@/api/dashboard/common';
import msgUtil from '@/utils/message';
import { isUnauthorizedFile } from '@/utils/file';
import { MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';

export default {
  name: 'WDashboardUploadForm',
  props: {
    value: {
      type: Object,
      default() {},
    },
  },
  data() {
    return {
      uploadData: this.value,
    };
  },
  watch: {
    value(val) {
      this.uploadData = val;
    },
  },
  methods: {
    onTemplateDownloadClick() {
      this.isLoading = true;
      DashboardAPI.downloadDashboardTemplate();
    },
    /**
     * 대시보드 템플릿 파일 선택 - 비인가 확장자 파일 업로드 불가능 기능 추가
     * @author KangBonghun(toto1323) -> NaJY
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    onChange(file) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(file)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      this.uploadData = file;

      this.$emit('input', file);
      this.$emit('changeUploadData', file);
    },
  },
};
</script>

<style module>
.desc {
  height: 100px;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 15px;
  color: #666; /* $evilgray */
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/form/DashboardUploadForm.vue